<p-dialog
  [(visible)]="displayDialog"
  [modal]="true"
  [resizable]="false"
  [draggable]="false"
  [style]="{ width: '45%' }"
  (onHide)="onHideDialog()"
>
  <ng-template #header>
    <div class="mb-2">
      <div>
        <span class="font-bold text-lg">Check in Counter Detail</span>
      </div>
    </div>
  </ng-template>

  <!-- Connected Device Status -->
  <div>
    <section class="grid grid-cols-12 gap-5 my-5">
      <!-- Def Port -->
      <div class="lg:col-span-6 col-span-12">
        <span class="font-bold">Def Port:</span>
        <span class="green-chip ml-2">{{ selectedItem()?.defPort || '-' }}</span>
      </div>

      <!-- Counter Name -->
      <div class="lg:col-span-6 col-span-12">
        <span class="font-bold">Counter Name:</span>
        <span class="green-chip ml-2">{{ selectedItem()?.computerName || '-' }}</span>
      </div>

      <!-- Check In System -->
      <div class="lg:col-span-6 col-span-12">
        <span class="font-bold">Check In System:</span>
        <span class="green-chip ml-2">{{ selectedItem()?.checkInSystem || '-' }}</span>
      </div>

      <!-- User Name -->
      <div class="lg:col-span-6 col-span-12">
        <span class="font-bold">User Name:</span>
        <span class="green-chip ml-2">{{ selectedItem()?.userName || '-' }}</span>
      </div>

      <!-- Electron Version -->
      <div class="lg:col-span-6 col-span-12">
        <span class="font-bold">Electron Version:</span>
        <span class="green-chip ml-2">{{ selectedItem()?.electronVersion || '-' }}</span>
      </div>

      <!-- Environment -->
      <div class="lg:col-span-6 col-span-12">
        <span class="font-bold">Environment:</span>
        <span class="green-chip ml-2">
          @switch (selectedItem()?.serverPingInformation?.Url) {
            @case ('acente.flypgs.com') {
              ACENTE
            }
            @case ('pax.flypgs.com') {
              PAX
            }
            @case ('fallback.flypgs.com') {
              FALLBACK
            }
            @case ('fallbacktest.flypgs.com') {
              FALLBACKTEST
            }
            @case ('paxcontrol.flypgs.com') {
              PAXCONTROL
            }
            @case ('pctest.flypgs.com') {
              PCTEST
            }
            @case ('prep.flypgs.com') {
              PREP
            }
            @case ('dracente.flypgs.com') {
              DR-ACENTE
            }
            @case ('drpax.flypgs.com') {
              DR-PAX
            }
            @default {
              {{ selectedItem()?.serverPingInformation?.Url || '-' }}
            }
          }
        </span>
      </div>

      <!-- Server Ip -->
      <div class="lg:col-span-6 col-span-12">
        <span class="font-bold">Server Ip:</span>
        <span class="green-chip ml-2">{{ selectedItem()?.serverIp || '-' }}</span>
      </div>

      <!-- Status -->
      <div class="lg:col-span-6 col-span-12">
        @if (getSessionStatus() === sessionStatus.history) {
          <div>
            <span class="font-bold">Status:</span>
            <span class="green-chip ml-2">
              Archived ({{ selectedItem()?.logoutTime | date: 'dd.MM.yyyy | HH:mm' }})
            </span>
          </div>
        }
      </div>
    </section>

    <section>
      <div class="p-4 text-center title-background">
        <span class="text-base">
          {{
            getSessionStatus() === sessionStatus.active
              ? 'Connected Device Status'
              : 'Last Connected Devices Status'
          }}
        </span>
      </div>

      <div class="flex py-4 overflow-x-auto">
        @if (getDeviceStatusList().length > 0) {
          @for (device of getDeviceStatusList(); track $index) {
            <div class="flex flex-col items-center mx-7">
              <div class="text-base text-gray-700 mb-1">
                <span>{{ device.name }}</span>
                <span *ngIf="device.status?.logical && device.status?.logical != 'null'">
                  {{ ' (' + device.status?.logical + ')' }}
                </span>
              </div>
              @if (device.status?.physical === 'Offline') {
                <div class="status-indicator error">
                  <div class="status-dot error"></div>
                </div>
              } @else {
                <div class="status-indicator">
                  <div class="status-dot"></div>
                </div>
              }
            </div>
          }
        } @else {
          <div>No data to display</div>
        }
      </div>
    </section>
  </div>

  <hr />

  <span class="font-bold text-[18px]">Last URL Details</span>
  <app-table-component
    [cols]="cols"
    [data]="getTableData()"
    [loading]="false"
    [pagination]="false"
  />

  <!-- Templates -->
  <ng-template #statusColumnTemplate let-rowData="rowData">
    <div [class]="rowData.status === 'Offline' ? 'status-indicator error' : 'status-indicator'">
      <div [class]="rowData.status === 'Offline' ? 'status-dot error' : 'status-dot'"></div>
    </div>
  </ng-template>

  <ng-template #respondTimeColumnTemplate let-rowData="rowData">
    @if (rowData.status === 'Offline') {
      <div class="text-[#F04438] font-bold">-</div>
    } @else {
      @if (rowData.responseTime > 0 && rowData.responseTime <= 650) {
        <div class="text-[#0E8345] font-bold">{{ rowData.responseTime }} ms</div>
      } @else if (rowData.responseTime > 650 && rowData.responseTime <= 1450) {
        <div class="text-[#FEB914] font-bold">{{ rowData.responseTime }} ms</div>
      } @else if (rowData.responseTime > 1450 && rowData.responseTime <= 2500) {
        <div class="text-[#F78330] font-bold">{{ rowData.responseTime }} ms</div>
      }@else if(rowData.responseTime > 2500) {
        <div class="text-[#F04438] font-bold">{{ rowData.responseTime }} ms</div>
      } @else {
        <div class="text-[#F04438] font-bold">-</div>
      }
    }
  </ng-template>
</p-dialog>
